import Markdown from 'markdown-to-jsx';

import { GraphConfigType } from '../types';

import './DashboardMarkdown.scss';

type DashboardMarkdownType = {
  config: GraphConfigType;
};

/**
 * Displays markdown as a dashboard graph.
 *
 * @prop config The dashboard graph config
  */
function DashboardMarkdown({
  config,
}: DashboardMarkdownType): JSX.Element {

  const markdown = (config.markdown || '');
  return (
    markdown.length > 0
      ? (
        <div className="DashboardMarkdown">
          <Markdown>{markdown}</Markdown>
        </div>
      )
      : <></>
  );
}

export default DashboardMarkdown;
